<template>
  <div class="mc-widget-call__call-item-container">
    <div class="mc-widget-call__vehicle-information">
      <h5 class="mc-widget-call__licenseplate">{{ licensePlate }}</h5>
      <p class="mc-widget-call__driver" :title="driver ?? $t('global.text.noDriver')">
        {{ driver ?? $t('global.text.noDriver') }}
      </p>
    </div>
    <div class="mc-widget-call__fail-connect">
      <p>{{ $t('trackVideo.failedToConnect') }}</p>
    </div>
    <div class="mc-widget-call__more-options-container">
      <b-dropdown
        variant="black"
        menu-class="p-0"
        right
        toggle-class="btn btn-more-options btn-outline-primary"
      >
        <template v-slot:button-content>
          <i class="mc-fa icon-outline_more-vertical"></i>
        </template>
        <b-dropdown-item @click="$emit('tryAgain')">
          <i class="mc-fa icon-outline_refresh"></i>
          <span>
            {{ $t('global.action.tryAgain') }}
          </span>
        </b-dropdown-item>
        <b-dropdown-item @click="$emit('stopCall')">
          <i class="mc-fa icon-outline_phone-off"></i>
          <span>
            {{ $t('trackVideo.end') }}
          </span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailConnect',
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      validator: (value) => typeof value === 'string' || value === null,
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
  },
}
</script>
